var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1.77417C1 1.56754 1.16751 1.40002 1.37415 1.40002H3.67347C3.88011 1.40002 4.04762 1.56754 4.04762 1.77417V4.44764C4.04762 6.36781 3.20176 7.76686 1.51004 8.64481C1.2727 8.76798 1 8.58764 1 8.32025V7.33642C1 7.1995 1.07583 7.07498 1.19152 7.00174C1.96462 6.51232 2.39425 5.78558 2.48039 4.82152C2.49879 4.6157 2.32909 4.44764 2.12245 4.44764H1.37415C1.16751 4.44764 1 4.28013 1 4.07349V1.77417ZM5.95238 1.77417C5.95238 1.56754 6.11989 1.40002 6.32653 1.40002H8.62585C8.83249 1.40002 9 1.56754 9 1.77417V4.44764C9 6.36781 8.15414 7.76686 6.46242 8.64481C6.22509 8.76798 5.95238 8.58764 5.95238 8.32025V7.33642C5.95238 7.1995 6.02821 7.07498 6.1439 7.00174C6.917 6.51232 7.34663 5.78557 7.43278 4.82152C7.45117 4.6157 7.28147 4.44764 7.07483 4.44764H6.32653C6.11989 4.44764 5.95238 4.28013 5.95238 4.07349V1.77417Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteIcon);
export default __webpack_public_path__ + "static/media/QuoteIcon.38801ce9b2d86b13778266dea2b29adc.svg";
export { ForwardRef as ReactComponent };